import { CountriesDomain } from 'core/typing/domains/CountriesDomain/CountriesDomain';
import { createEvent } from 'effector';

export const loadCountries = createEvent('loadCountries');
export const loadCountriesDone = createEvent<CountriesDomain>('loadCountriesDone');
export const loadCountriesFail = createEvent('loadCountriesFail');
